<template>
  <div v-if="characteristics.length > 0" class="caracteristicas ui-container">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="ui-subtitle--interna">
            <h2>
              Características Gerais
            </h2>
          </div>
        </div>
        <div class="col-12">
          <div class="lista">
            <ul class="row justify-content-center">
              <li class="col-lg-3 col-md-4 col-12" v-for="(item,index) in characteristics" :key="index">
                <div class="lista__box">
                  <div v-if="item.image" class="lista__box__image__area">
                  <!-- tamanho de imagem para cadastrar aqui: 50x50px -->
                    <div class="lista__box__image ui-image--cover" :style="'background-image: url('+item.image+')'">
                    </div>
                  </div>
                  <div class="lista__box__title">
                    <h3>
                      {{item.title}}
                    </h3>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['characteristics']
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.caracteristicas {
  background: $bgIntern;
  .lista {
    li {
      margin-bottom: 30px;
    }
    &__box {
      background: white;
      border-radius: 10px;
      box-shadow: 10px 10px 35px 0px rgba(0, 26, 66, 0.2);
      height: 100%;
      padding: 80px 50px 50px 50px;
      &__image__area {
        min-height: 80px;
      }
      &__image {
        height: 50px;
        margin: 0 auto;
        position: relative;
        width: 50px;
        &:before {
          border: 2px $green solid;
          border-radius: 100px;
          content: '';
          height: 100px;
          left: calc(50% - 50px);
          position: absolute;
          top: -25px;
          width: 100px;
        }
      }
      &__title {
        margin-top: 30px;
        min-height: 60px;
        h3 {
          color: $primary;
          font-size: 24px;
          font-style: italic;
          font-weight: 600;
          text-align: center;
        }
      }
    }
    @media (max-width: 1200px) {
      &__box {
        padding: 50px 30px 30px 30px;
        &__title {
          h3 {
            font-size: 20px;
          }
        }
      }
    }
    @media (max-width: 991px) {
      &__box {
        padding: 50px 20px 20px 20px;
        &__title {
          margin-top: 20px;
          h3 {
            font-size: 20px;
          }
        }
      }
    }
    @media (max-width: 767px) {
      &__box {
        &__title {
          min-height: inherit;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/InternaApresentacaoCaracteristicas.vue